
export const WhitelabelIosIcons = [
    "AppIcon-20x20@1x.png",
    "AppIcon-20x20@2x-1.png",
    "AppIcon-20x20@2x.png",
    "AppIcon-20x20@3x.png",
    "AppIcon-29x29@1x.png",
    "AppIcon-29x29@2x-1.png",
    "AppIcon-29x29@2x.png",
    "AppIcon-29x29@3x.png",
    "AppIcon-40x40@1x.png",
    "AppIcon-40x40@2x-1.png",
    "AppIcon-40x40@2x.png",
    "AppIcon-40x40@3x.png",
    "AppIcon-512@2x.png",
    "AppIcon-60x60@2x.png",
    "AppIcon-60x60@3x.png",
    "AppIcon-76x76@1x.png",
    "AppIcon-76x76@2x.png",
    "AppIcon-83.5x83.5@2x.png"
]

export const IOS_ICONS_DEFAULT_FOLDER = 'ios-icons';
export const IOS_CREDENTIALS_DEFAULT_FOLDER = 'ios-credentials';
export const IOS_GOOGLE_SERVICE_INFO_PLIST_NAME = 'GoogleService-Info.plist';

export const IOS_TRACKS: WhitelabelIosDeploymentTracks[] = ['TestFlight', 'Production'];
export type WhitelabelIosDeploymentTracks = 'TestFlight' | 'Production';

export interface IWhitelabelIosPayload {
    accountantId: string;
    name: string;
    apiKeyId: string;
    intentScheme?: string;
    intentUrl?: string;
    apiKeyIssuerId: string;
    apiTokenBase64: string;
    bundleIdentifier: string;
    appId: string;
    oneSignalAppId: string;
    track?: WhitelabelIosDeploymentTracks;
    releaseNotes: string;
    versionName: string;
    versionCode: string;
}

export class WhitelabelIosConfigLogicAppPayload implements IWhitelabelIosPayload {
    accountantId!: string;
    name!: string;
    intentScheme?: string;
    intentUrl?: string;
    apiKeyId!: string;
    apiKeyIssuerId!: string;
    apiTokenBase64!: string;
    bundleIdentifier!: string;
    appId!: string;
    oneSignalAppId!: string;
    track?: WhitelabelIosDeploymentTracks;
    releaseNotes!: string;
    versionName!: string;
    versionCode!: string;

    public constructor(payload: IWhitelabelIosPayload) {
        Object.assign(this, payload);
    }
}


export class WhitelabelIosConfig {
    public name!: string;
    public intentScheme!: string;
    public developmentTeam!: string | null;
    public appId!: string | null;
    public iosBundleId!: string | null;
    public applicationGroup!: string | null;
    public apiKeyId!: string | null;
    public apiKeyIssuerId!: string | null;
    public apiTokenBase64!: string | null;
    public status!: number;
    public oneSignalBundleId!: string | null;
    public appProvisionProfileSpecifier!: string;
    public oneSignalProvisionProfileSpecifier!: string | null;
    public associatedDomain!: string;

    public appProvisionProfileLink!: string | null;
    public oneSignalProvisionProfileLink!: string | null;
    public certificateLink!: string | null;
    public iconsLink!: string[] | null;
    public appIconLink!: string | null;
    public googleServicePlistLink!: string | null;
    public iosCertificateExpiryDate!: string | null;

    public constructor() { }

    public generateAppReleaseXcconfigFile(deepLinkHost: string): File {
        if (!!this.developmentTeam && !!this.name &&
            !!this.iosBundleId && !!this.appProvisionProfileSpecifier &&
            !!this.associatedDomain && !!this.applicationGroup) {
            const content = `
                   #include "../Pods/Target Support Files/Pods-App/Pods-App.release.xcconfig"
                   #include "App-Shared.xcconfig"
           
                   DEEPLINK_ENABLED = YES
                   DEEPLINK_HOST = ${deepLinkHost}
           
                   DEVELOPMENT_TEAM[sdk=iphoneos*] = ${this.developmentTeam}
           
                   DISPLAY_NAME = ${this.name}
                   PRODUCT_BUNDLE_IDENTIFIER = ${this.iosBundleId}
                   INTENT_SCHEME = ${this.intentScheme}
           
                   CODE_SIGN_IDENTITY = iPhone Distribution
                   PROVISIONING_PROFILE_SPECIFIER[sdk=iphoneos*] = ${this.appProvisionProfileSpecifier}
           
                   MARKETING_VERSION = 5.0.4
                   CURRENT_PROJECT_VERSION = 1
           
                   ASSOCIATED_DOMAINS = ${this.associatedDomain}
                   APPLICATION_GROUPS = ${this.applicationGroup}
                   `

            const blob = new Blob([content], { type: '.xcconfig' });
            const file = new File([blob], 'App-Release.xcconfig');
            return file;
        }

        throw new Error('Cant create XCConfig file');
    }

    public generateOneSignalReleaseXcconfigFile(): File {
        if (!!this.developmentTeam && !!this.oneSignalBundleId &&
            !!this.oneSignalProvisionProfileSpecifier && !!this.applicationGroup) {
                const content = `
                #include "../Pods/Target Support Files/Pods-OneSignalNotificationServiceExtension/Pods-OneSignalNotificationServiceExtension.release.xcconfig"
                #include "OneSignal-Shared.xcconfig"
        
                DEVELOPMENT_TEAM[sdk=iphoneos*] = ${this.developmentTeam}
        
                PRODUCT_BUNDLE_IDENTIFIER = ${this.oneSignalBundleId}
        
                CODE_SIGN_IDENTITY = iPhone Distribution
                PROVISIONING_PROFILE_SPECIFIER[sdk=iphoneos*] = ${this.oneSignalProvisionProfileSpecifier}
        
                MARKETING_VERSION = 5.0.4
                CURRENT_PROJECT_VERSION = 1
        
                APPLICATION_GROUPS = ${this.applicationGroup}
                `
        
                const blob = new Blob([content], { type: '.xcconfig' });
                const file = new File([blob], 'OneSignal-Release.xcconfig');
                return file;
            }

            throw new Error('Cant create OneSignal XCConfig file');
    }
}
